// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3jFuV","notes":"Notes_notes__3TcsL"};